var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgD411(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_205_1472)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0864 31.8395C11.2412 31.9703 11.5021 32.001 11.6556 31.8271C11.7396 31.7318 11.8571 31.5188 11.9649 31.1497C12.0079 31.0025 12.0452 30.8452 12.0774 30.682C11.5893 30.8567 11.2114 31.065 11.0159 31.2867C10.8624 31.4606 10.9315 31.7087 11.0864 31.8395ZM12.2518 28.9898C13.1113 28.7882 13.8269 28.733 13.8269 28.733C13.8269 28.733 13.846 29.4316 13.7599 30.2822C13.6656 31.2141 13.445 32.3286 12.9344 32.9073C12.2924 33.6351 11.0562 33.6205 10.1732 32.8746C9.29025 32.1288 9.09495 30.9342 9.73698 30.2064C10.2972 29.5713 11.3532 29.2006 12.2518 28.9898Z",
    fill: "url(#paint0_linear_205_1472)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5244 22.9956L17.8259 23.5212L17.9702 24.4289L17.1336 24.2657L16.6433 25.0185L16.1586 24.262L15.3208 24.4189L15.472 23.5124L14.7775 22.9815L15.4759 22.4559L15.3316 21.5482L16.1682 21.7115L16.6586 20.9587L17.1432 21.7152L17.9811 21.5582L17.8299 22.4648L18.5244 22.9956ZM14.0675 26.5519L14.766 26.0263L14.0715 25.4955L14.2227 24.5889L13.3849 24.7459L12.9002 23.9894L12.4098 24.7422L11.5732 24.5789L11.7175 25.4866L11.0191 26.0122L11.7136 26.5431L11.5624 27.4496L12.4002 27.2927L12.8849 28.0492L13.3752 27.2964L14.2119 27.4596L14.0675 26.5519ZM17.8029 29.6109L18.5014 29.0853L17.8069 28.5544L17.9581 27.6479L17.1203 27.8048L16.6356 27.0483L16.1453 27.8011L15.3086 27.6379L15.453 28.5456L14.7545 29.0712L15.449 29.602L15.2978 30.5086L16.1356 30.3516L16.6203 31.1081L17.1107 30.3553L17.9473 30.5186L17.8029 29.6109ZM21.5613 26.5802L22.2598 26.0546L21.5653 25.5237L21.7165 24.6172L20.8787 24.7741L20.394 24.0176L19.9036 24.7704L19.067 24.6072L19.2114 25.5149L18.5129 26.0405L19.2074 26.5713L19.0562 27.4779L19.894 27.3209L20.3787 28.0774L20.8691 27.3246L21.7057 27.4879L21.5613 26.5802Z",
    fill: "url(#paint1_linear_205_1472)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 26.2848C4.91752 24.7538 2 20.699 2 15.9375C2 9.86237 6.74949 4.9375 12.6083 4.9375C17.469 4.9375 21.5661 8.32726 22.821 12.9514C22.9626 12.9422 23.1054 12.9375 23.2493 12.9375C26.9776 12.9375 30 16.0715 30 19.9375C30 23.5403 27.375 26.5075 24 26.8947V24.8745C26.2205 24.499 28 22.4861 28 19.9375C28 17.1071 25.8053 14.9375 23.2493 14.9375C22.5272 14.9375 21.8339 15.1107 21.2108 15.423C21.1791 14.8412 21.0937 14.2742 20.9599 13.7274L20.9569 13.7286C20.0091 9.78754 16.5839 6.9375 12.6083 6.9375C7.92179 6.9375 4 10.898 4 15.9375C4 19.5991 6.0703 22.691 9 24.1081V26.2848Z",
    fill: "url(#paint2_linear_205_1472)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 6.47529C9.52316 2.81685 12.7644 0 16.6848 0C19.9997 0 22.829 2.01388 23.9402 4.84757C24.0099 4.84503 24.08 4.84375 24.1503 4.84375C27.1879 4.84375 29.6503 7.22923 29.6503 10.1719C29.6503 12.1966 28.4845 13.9576 26.7677 14.8592C25.6122 14.0437 24.1893 13.5626 22.6503 13.5626L22.6168 13.5627C22.6168 13.5626 22.6167 13.5626 22.6167 13.5625H24.2105V13.4995C26.1739 13.4687 27.6503 11.9326 27.6503 10.1719C27.6503 8.39318 26.1436 6.84375 24.1503 6.84375C23.4924 6.84375 22.8876 7.01252 22.3724 7.30261L22.3725 7.26562C22.3725 6.79173 22.3086 6.33229 22.1888 5.89494C21.4719 3.6681 19.3168 2 16.6848 2C13.9872 2 11.7904 3.75246 11.1299 6.06281C10.3961 6.13195 9.68367 6.27182 9 6.47529Z",
    fill: "url(#paint3_linear_205_1472)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_205_1472",
    x1: 13.8269,
    y1: 28.733,
    x2: 10.2638,
    y2: 32.9512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95B6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5193DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_205_1472",
    x1: 16.6586,
    y1: 20.9587,
    x2: 16.6203,
    y2: 31.1081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95B6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5193DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_205_1472",
    x1: 16,
    y1: 4.9375,
    x2: 16,
    y2: 26.8947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9E2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_205_1472",
    x1: 19.3251,
    y1: 0,
    x2: 19.3251,
    y2: 14.8592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9E2F3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_205_1472"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 31,
    fill: "white",
    transform: "translate(0 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD411);
export default __webpack_public_path__ + "static/media/d411.d89b77dbde79d4b130eae8b787abf2bc.svg";
export { ForwardRef as ReactComponent };